import { Box, Flex } from '@rebass/grid'
import * as queryString from 'query-string'
import * as React from 'react'
import Headroom from 'react-headroom'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import MaterialDiscussion from 'src/components/MaterialDiscussion'
import Navbar from 'src/components/Navbar'
import { dispatch, RootState } from 'src/store'
import styled from 'styled-components'
import Banner from './Banner'
import Toolbar from './Footer'
import InsightEnded from './InsightEnded'
import LectureContent from './LectureContent'
import LectureHeader from './LectureHeader'

interface IState {}

const Background = styled(Flex)`
  min-height: calc(100vh - 248px);
  justify-content: center;
  background-color: #f4f5f7;
  padding-bottom: 40px;
`

const LectureContentContainer = styled(Box)`
  flex: 1;
  top: -68px;
  max-width: 940px;
`

type IProps = RouteComponentProps<any> & ReturnType<typeof mapState>

class LectureContentPage extends React.Component<IProps, IState> {
  public handleInsightEndedClose = () => {
    dispatch.lectureContent.closeInsightEnded()
  }
  public handleInsightNext = () => {
    const {
      history,
      currentLectureId,
      currentLecture,
      currentChapterIdx
    } = this.props
    if (currentLecture) {
      const chapter = currentLecture.units[0].chapters[currentChapterIdx + 1]
      if (chapter) {
        history.push(
          `/lectures/${currentLectureId}/content?chapterIdx=${currentChapterIdx +
            1}&insightId=${chapter.insightIds[0]}&materialIdx=0`
        )
        dispatch.lectureContent.closeInsightEnded()
      }
    }
  }
  public changeCurrentFromUrl = (props: IProps) => {
    // switch current lecture
    const { match } = this.props
    const lectureId: string = match.params.lectureId
    dispatch.stats.fetchStats(lectureId)
    dispatch.lectureContent.changeCurrentLecture(lectureId).then(_ => {
      // fetch queries
      const queries = queryString.parse(location.search)
      // if chapter is selected
      if (queries.chapterIdx) {
        const currentChapterIdx = parseInt(
          Array.isArray(queries.chapterIdx)
            ? queries.chapterIdx[0]
            : queries.chapterIdx,
          10
        )
        dispatch.lectureContent.updateLectureContentState({
          currentChapterIdx
        })
        // if insight is selected
        if (queries.insightId) {
          const currentInsightId = Array.isArray(queries.insightId)
            ? queries.insightId[0]
            : queries.insightId
          dispatch.lectureContent.updateLectureContentState({
            currentInsightId
          })
          // if material is selected
          if (queries.materialIdx) {
            const currentMaterialIdx = parseInt(
              Array.isArray(queries.materialIdx)
                ? queries.materialIdx[0]
                : queries.materialIdx,
              10
            )
            dispatch.lectureContent.updateLectureContentState({
              currentMaterialIdx
            })
            // if reply is selected
            if (queries.replyId) {
              const currentReplyId = Array.isArray(queries.replyId)
                ? queries.replyId[0]
                : queries.replyId
              dispatch.lectureContent.updateLectureContentState({
                currentReplyId
              })
              dispatch.discussion.changeCurrentDiscussion({
                chapterIdx: currentChapterIdx,
                insightId: currentInsightId,
                materialIdx: currentMaterialIdx
              })
            }
          }
        }
      }
    })
  }
  public componentWillReceiveProps = (nextProps: IProps) => {
    if (nextProps.match !== this.props.match) {
      this.changeCurrentFromUrl(nextProps)
    }
  }
  public componentDidMount = () => {
    this.changeCurrentFromUrl(this.props)
  }
  public render() {
    const {
      showDiscussion,
      showInsightEnded,
      currentLecture,
      currentLectureId,
      currentChapterIdx
    } = this.props
    return (
      <React.Fragment>
        <Headroom style={{ zIndex: 10 }}>
          <Navbar />
        </Headroom>
        <Banner lecture={currentLecture} lectureId={currentLectureId} />
        <Background>
          <LectureContentContainer>
            <LectureHeader
              lectureId={currentLectureId || ''}
              lecture={currentLecture}
            />
            <LectureContent />
          </LectureContentContainer>
        </Background>
        <Toolbar lecture={currentLecture} />
        {showDiscussion ? <MaterialDiscussion /> : null}
        {showInsightEnded ? (
          <InsightEnded
            chapterIdx={currentChapterIdx}
            chapterTitle={
              currentLecture
                ? currentLecture.units[0].chapters[currentChapterIdx].title
                : ''
            }
            onClose={this.handleInsightEndedClose}
            onDiscuss={this.handleInsightEndedClose}
            onNext={this.handleInsightNext}
          />
        ) : null}
      </React.Fragment>
    )
  }
}

const mapState = ({ lectureContent, discussion, lectures }: RootState) => {
  return {
    showDiscussion: discussion.isOpen,
    showInsightEnded: lectureContent.showInsightEnded,
    currentLectureId: lectureContent.currentLectureId,
    currentChapterIdx: lectureContent.currentChapterIdx,
    currentLecture: lectureContent.currentLectureId
      ? lectures[lectureContent.currentLectureId]
      : null
  }
}

export default connect(mapState)(LectureContentPage)



// WEBPACK FOOTER //
// ./src/pages/LectureContentPage/index.tsx